import React, { useEffect, useState } from 'react';

interface StatsDisplayProps {
  totalRecords?: number;
  totalPhoneNumbers?: number;
  totalEmails?: number;
  totalFacebooks?: number;
  messages: Array<React.ReactNode>;
  showRecords?: boolean;
  showPhoneNumbers?: boolean;
  showEmails?: boolean;
  showFacebook?: boolean;
  icons: Array<React.ReactNode>;
  recordLink?: string;
  phoneNumberLink?: string;
  emailLink?: string;
  facebookLink?: string;
}

// export const formatNumber = (num: number | undefined): string => {
//   if (num === undefined || num === null || isNaN(num)) {
//     return '0'; 
//   }

//   if (num < 1000) {
//     return num.toString();
//   } else if (num < 1_000_000) {
//     return (num / 1_000).toFixed(0) + 'K';
//   } else {
//     return (num / 1_000_000).toFixed(0) + 'M';
//   }
// };


export const formatNumber = (num: number | undefined): string => {
  if (num === undefined || num === null || isNaN(num)) {
    return '0'; // Handle undefined or invalid numbers
  }

  if (num < 1000) {
    return num.toString();
  } else if (num < 1_000_000) {
    return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K'; // Format as thousand
  } else {
    return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M'; // Format as million
  }
};

const SocialCounter: React.FC<StatsDisplayProps> = ({
  totalRecords = 0,
  totalPhoneNumbers = 0,
  totalEmails = 0,
  totalFacebooks = 0,
  messages = [],
  showRecords = true,
  showPhoneNumbers = true,
  showEmails = true,
  showFacebook = false,
  icons = [],
  recordLink,
  phoneNumberLink,
  emailLink,
  facebookLink
}) => {
  const [activeBox, setActiveBox] = useState(0);

  // Filter the messages to match visible boxes
  const visibleMessages = [
    showRecords && totalRecords > 0 ? messages[0] : null,
    showPhoneNumbers && totalPhoneNumbers > 0 ? messages[1] : null,
    showEmails && totalEmails > 0 ? messages[2] : null,
    showFacebook && totalFacebooks > 0 ? messages[3] : null,
  ].filter(Boolean); // Remove null values

  useEffect(() => {
    if (visibleMessages.length === 0) return;

    const interval = setInterval(() => {
      setActiveBox((prev) => (prev + 1) % visibleMessages.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [visibleMessages.length]);

  const columns = [
    showRecords,
    showPhoneNumbers,
    showEmails,
    showFacebook
  ].filter(Boolean).length;
  
  const boxWidth = 'w-40';
  
  const renderBoxContent = (count: number, icon: React.ReactNode) => (
    <div className="flex items-center justify-center gap-1">
      <div className="text-2xl text-[#1482ff]">{icon}</div>
      <div className="text-2xl font-bold">
        {count > 0 ? formatNumber(count) : 'N/A'}
      </div>
    </div>
  );
  
  
  return (
    <div className="flex flex-col items-center">
  {(showRecords || showPhoneNumbers || showEmails || showFacebook) && (
    <div className={`lg:flex text-center md:mb-4 mb-4 border shadow-lg divide-y text-[var(--title-color)] divide-slate-300 bg-white rounded-lg overflow-hidden`}>
      {showRecords && (
        recordLink ? (
          <a href={recordLink} className={`p-4 h-28 flex flex-col items-center justify-center ${boxWidth}`} title={`${totalRecords}`}>
            {renderBoxContent(totalRecords, icons[0])}
          </a>
        ) : (
          <div className={`p-4 h-28 flex flex-col items-center justify-center ${boxWidth}`}>
            {renderBoxContent(totalRecords, icons[0])}
          </div>
        )
      )}

      {showPhoneNumbers && (
        phoneNumberLink ? (
          <a href={phoneNumberLink} className={`p-4 h-28 flex flex-col items-center justify-center ${boxWidth}`} title={`${totalPhoneNumbers}`}>
            {renderBoxContent(totalPhoneNumbers, icons[1])}
          </a>
        ) : (
          <div className={`p-4 h-28 flex flex-col items-center justify-center ${boxWidth}`}>
            {renderBoxContent(totalPhoneNumbers, icons[1])}
          </div>
        )
      )}

      {showEmails && (
        emailLink ? (
          <a href={emailLink} className={`p-4 h-28 flex flex-col items-center justify-center ${boxWidth}`} title={`${totalEmails}`}>
            {renderBoxContent(totalEmails, icons[2])}
          </a>
        ) : (
          <div className={`p-4 h-28 flex flex-col items-center justify-center ${boxWidth}`}>
            {renderBoxContent(totalEmails, icons[2])}
          </div>
        )
      )}

      {showFacebook && (
        facebookLink ? (
          <a href={facebookLink} className={`p-4 h-28 flex flex-col items-center justify-center ${boxWidth}`} title={`${totalFacebooks}`}>
            {renderBoxContent(totalFacebooks, icons[3])}
          </a>
        ) : (
          <div className={`p-4 h-28 flex flex-col items-center justify-center ${boxWidth}`}>
            {renderBoxContent(totalFacebooks, icons[3])}
          </div>
        )
      )}
    </div>
  )}

  <div className="mb-4 tracking-wide text-2xl text-[var(--title-color)] font-semibold text-center md:text-left">
    <ul>
      {visibleMessages.map((message, index) => (
        <li key={index} className={activeBox === index ? 'block' : 'hidden'}>
          {message}
        </li>
      ))}
    </ul>
  </div>
</div>

  );
};

export default SocialCounter;
